import { type FC, type ComponentProps, type ReactNode } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { HpSharedViewMoreLink } from '../HpSharedViewMoreLink/HpSharedViewMoreLink.tsx';

import styles from './HpSharedHeader.scss';

type Props = {
    title?: ReactNode;
    subtitle?: string;
    viewMoreLink?: string | null;
    viewMoreText?: ReactNode;
    onViewMoreClick?: ComponentProps<typeof Link>['onClick'];
    dataTn?: string;
    size?: 'large' | 'larger';
};

export const HpSharedHeader: FC<Props> = ({
    title,
    subtitle,
    viewMoreLink,
    viewMoreText,
    onViewMoreClick,
    dataTn,
    size = 'large',
}) =>
    title ? (
        <div className={classnames(styles.headerContainer, styles[size])}>
            <div className={styles.titleWrapper}>
                <div
                    className={classnames(styles.title, styles[size])}
                    data-tn={dataTn ? `${dataTn}-title` : null}
                >
                    {title}
                </div>
                {viewMoreLink && (
                    <HpSharedViewMoreLink
                        viewMoreLink={viewMoreLink}
                        viewMoreText={viewMoreText}
                        onViewMoreClick={onViewMoreClick}
                        size={size}
                        dataTn={dataTn}
                    />
                )}
            </div>
            {subtitle && <div className={styles.subtitle}>{subtitle}</div>}
        </div>
    ) : null;
